export function applyGloablMixin(vue) {
    vue.mixin({
        methods: {
            packageShow(pkg) {
                const language = this.$i18n.locale;
                const name = language === 'cn' ? pkg.package_name : pkg.en_name;
                return name;
            },
        },
    });
}
